import * as $ from "jquery";
import storage from "../utils/storage";
import url from '../utils/url';

export default class HeaderlessNavbar {
  $navbar: JQuery<HTMLElement>;
  TARGET_HOSTNAME = 'atlassian.com';
  HEADERLESS_NAV_CLASS = 'headerless-nav';
  STORAGE_KEY_DISABLE = 'disable_product_nav';
  STORAGE_KEY_CONTEXT = 'context_product_nav';

  constructor(domRoot: HTMLElement) {
    this.$navbar = $(domRoot);
  }

  shouldUseHeaderlessNav() {
    if (!$('body').hasClass(this.HEADERLESS_NAV_CLASS)) {
      return false;
    }

    if (storage.getSessionStorage(this.STORAGE_KEY_DISABLE)) {
      return false;
    }

    let ref = document.referrer;
    let isRefExternal = ref ? url.getHostname(ref).indexOf(this.TARGET_HOSTNAME) === -1 : true;

    let headerlessContextPath = storage.getSessionStorage(this.STORAGE_KEY_CONTEXT);
    if (!headerlessContextPath) {
      headerlessContextPath = $('body').data('headerless-path').replace(/\/wac\//, '/');
      storage.setSessionStorage(this.STORAGE_KEY_CONTEXT, headerlessContextPath);
    }

    let isSimilarContextPath = this.isHeaderlessNavBarInContext(ref, headerlessContextPath);
    if (!ref || isRefExternal || isSimilarContextPath ) {
      return true;
    }
    return false;
  }

  disableHeaderlessNav() {
    $('body').removeClass(this.HEADERLESS_NAV_CLASS);
    storage.setSessionStorage(this.STORAGE_KEY_DISABLE, '1');
    storage.removeSessionStorage(this.STORAGE_KEY_CONTEXT);
  }

  initHeaderlessNav() {
    const $globalProductsLink = $('.global-nav--wac__link.has-dropdown a[data-dropdown-id="dropdown-b7fc3020"]');
    const $subnavProductsLink = $('.imkt-navbar__link-list--products');
    const $globalNavLogo = $('.global-nav--wac__logo');
    const $globalNavLinks = $('.global-nav--wac__links');
    const $titleLink = this.$navbar.find('.imkt-navbar__title-link');
    const $globalHeader = $('.header--wac');
    const $globalNavProfile = $('#global-nav--wac__container--profile');
    const $rightNav = $('.imkt-navbar__right-nav');

    // Stop and disable headerless nav if no products menu found
    if (!$globalProductsLink.length || !$subnavProductsLink.length) {
      this.disableHeaderlessNav();
      return;
    }

    // Make global nav sticky (only visible for mobile layout)
    $globalHeader.addClass('imkt-sticky');

    // Bind click event to product icon
    $subnavProductsLink.on('click', (e) => {
      e.preventDefault();
      $globalProductsLink.trigger('click');
    });

    // Run once for global nav modifications (in the event a page has multiple subnavs)
    if (!$globalHeader.hasClass('headerless-nav-processed')) {

      // Append subnavbar links into global nav mobile links
      this.$navbar.find('.imkt-navbar__link-list a:not(.imkt-navbar__link-list-link--dropdown-trigger)').each( (index, element) => {
        let $subnavLink = $(element).clone();
        $globalNavLinks.append($subnavLink);
      });

      // Update global nav logo with subnav link
      $globalNavLogo.find('a').attr( 'href', $titleLink.attr('href') );

      // Update global nav logo with subnav link logo or text
      let $titleLinkTextLogo = $titleLink.find('.imkt-navbar__title-text');
      if ($titleLinkTextLogo.length) {

        $globalNavLogo.find('img').hide();
        $globalNavLogo.append( $titleLinkTextLogo.clone() );

      } else {

        $globalNavLogo.find('img').attr( 'src', $titleLink.find('img').attr('src') );

      }

      // Move globalNavProfile to headerless nav
      $globalNavProfile.detach().appendTo($rightNav);

      // Set class on header to halt processing more than once
      $globalHeader.addClass('headerless-nav-processed');
    }

    // Ready class to show the headerless nav
    this.$navbar.addClass('ready');

  }

  isHeaderlessNavBarInContext(referrer: string, contextPath: string | null) {
    if (!contextPath) {
      return false;
    }

    let currentPath = window.location.pathname;
    if ( this.isNestedJiraTourPath(contextPath) !== this.isNestedJiraTourPath(currentPath) ) {
      return false;
    }

    if (referrer.indexOf(contextPath) > -1 && currentPath.indexOf(contextPath) > -1) {
      return true;
    }

    return false;
  }

  isNestedJiraTourPath(pathname: string) {
    let nestedTourPaths = [
      '/software/jira/service-desk',
      '/software/jira/core'
    ];

    for (let i = 0; i < nestedTourPaths.length; i++) {
      if ( pathname.indexOf(nestedTourPaths[i]) !== -1 ) {
        return true;
      }
    }
    return false;
  }

}
